<template>
  <section-container>
    <header-page
      title_header="Novo pedido"
      sub_header="Adicione um novo pedido"
    />
    <ui-modal ref="modal1" title="Produtos">
      <div class="flex flex-wrap font-display">
        <div class="w-full">
          <input-search @search="doProducts" />
        </div>
        <div
          class="w-full flex items-center border rounded-lg shadow-2l my-2"
          v-for="product in products.data"
          :key="product.id"
        >
          <div class="p-4">
            <image-product
              :storeId="store.id"
              :productId="product.id"
              class="w-12 rounded-lg"
            />
          </div>

          <h3 class="font-bold text-lg flex-grow">{{ product.name }}</h3>
          <div class="p-4">
            <button
              v-if="!existProduct(product)"
              @click="selectProduct(product)"
              class="px-4 py-3 bg-indigo-600 text-white rounded-lg"
            >
              Adicionar
            </button>
            <span v-else>Adicionado</span>
          </div>
        </div>
      </div>
    </ui-modal>
    <content-e>
      <div class="w-full rounded-lg bg-white shadow-2l">
        <div class="bg-white shadow-2l rounded p-6">
          <h2
            class="text-md font-bold mb-4 pb-4 border-b border-dashed block w-full"
          >
            Informações da Principais
          </h2>
          <form
            action=""
            class="flex flex-wrap w-full"
            ref="formCategories"
            @submit.prevent="doCreateOrder"
          >
            <div class="w-full p-2 flex flex-wrap">
              <div class="w-full md:w-1/2 p-2">
                <input-icon
                  :icon="{ name: 'user', type: 'solid' }"
                  id="name"
                  name="name"
                  type="text"
                  v-model="name"
                  label="Nome completo:"
                ></input-icon>
              </div>
              <div class="w-full md:w-1/2 p-2">
                <input-icon
                  :icon="{ name: 'envelope', type: 'solid' }"
                  id="email"
                  name="email"
                  type="text"
                  v-model="email"
                  label="E-mail:"
                ></input-icon>
              </div>
              <div class="w-full md:w-1/2 p-2">
                <input-icon
                  :icon="{ name: 'phone', type: 'solid' }"
                  id="phone"
                  name="phone"
                  type="text"
                  v-model="phone"
                  v-mask="['(##) #####-####']"
                  label="Telefone:"
                ></input-icon>
              </div>
              <h2
                class="text-md font-bold pb-4 border-b border-dashed block w-full"
              >
                Método de pagamento
              </h2>

              <div class="w-full flex-flex-nowrap">
                <div class="w-full flex flex-wrap items-center py-6">
                  <select
                    required
                    id="payment_method"
                    v-model="payment_method"
                    name="payment_method"
                    placeholder="Selecione o pagamento"
                    class="border w-full md:w-auto py-4 px-6 rounded bg-white focus:border-indigo-500 focus:shadow-focus focus:outline-none"
                  >
                    <option default value=""> Selecione o pagamento</option>
                    <option
                      v-for="paymentMethod in store.store_payment_methods"
                      :key="paymentMethod.id"
                      :value="paymentMethod.id"
                      :selected="
                        store.store_payment_methods[0].id === paymentMethod.id
                      "
                    >
                      {{ paymentMethod.name }}</option
                    >
                  </select>
                </div>
              </div>
              <h2
                class="text-md font-bold pb-4 border-b border-dashed block w-full"
              >
                Adicionar produtos ao pedido
              </h2>
              <div
                class="w-full flex flex-nowrap"
                v-if="products_selects.length"
              >
                <div class="w-full flex flex-wrap items-center p-6">
                  <div
                    v-for="productSelected in products_selects"
                    :key="`product-selected-${productSelected.id}`"
                    class="font-bold justify-center items-center w-full md:w-1/4 rounded-lg p-4 relative"
                  >
                    <div class="p-4 absolute top-0 right-0">
                      <button
                        @click="removeProduct(productSelected)"
                        type="button"
                        class="font-medium focus:outline-none px-4 py-2 bg-red-100 text-red-600 text-lg rounded-full text-center border-2 border-transparent focus:border-red-600"
                      >
                        <font-awesome-icon icon="trash-alt" />
                        <ui-tooltip position="bottom" animation="fade"
                          >Remover</ui-tooltip
                        >
                      </button>
                    </div>
                    <div
                      class="flex flex-col border-2 bg-gray-100 shadow-2l p-4 py-6 rounded items-center"
                    >
                      <image-product
                        :storeId="store.id"
                        :productId="productSelected.id"
                        class="w-12 rounded-lg"
                      ></image-product>
                      <h3 class="my-5 font-bold text-xl">
                        {{ productSelected.name }}
                      </h3>
                      <div class="">
                        <input
                          v-model="productSelected.quantity"
                          type="text"
                          class="border rounded-lg px-4 py-2 w-full"
                          placeholder="Quantidade:"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="w-full p-2 my-5">
                <div
                  @click="openModal('modal1')"
                  class="w-full bg-indigo-100 py-6 px-6 md:py-6 md:px-6 rounded-lg flex flex-wrap justify-center"
                >
                  <button-icon
                    icon="plus"
                    type="button"
                    text="Adicionar Produto"
                    class="bg-indigo-600 w-full"
                  />
                </div>
              </div>
              <h2
                v-if="false"
                class="text-md font-bold mb-4 pb-4 border-b border-dashed block w-full"
              >
                Endereço
              </h2>
              <div v-if="false" class="w-full md:w-1/2 flex flex-wrap">
                <div class="w-full p-2">
                  <input-icon
                    :icon="{ name: 'map' }"
                    id="address_zipcode"
                    name="address[zipcode]"
                    type="text"
                    v-mask="'#####-###'"
                    v-model="zipcode"
                    max="9"
                    label="Cep:"
                  ></input-icon>
                  <small
                    >Informe o cep do endereço atual para preenchimento
                  </small>
                </div>
              </div>
              <div
                v-if="address_card"
                class="w-full rounded border-b-4 border-indigo-500"
              >
                <div class="flex flex-wrap">
                  <div
                    class="w-full md:w-12/12 md:mb-0 p-4 md:p-4 border-2 border-b-0 border-gray-200"
                  >
                    <h3 class="text-md font-bold">Endereço</h3>
                    <p class="text-lg my-5">
                      Rua: {{ address.street }},
                      <span v-if="address.number" class="font-bold"
                        >N°{{ address.number }}</span
                      >
                      <span v-if="address.complement" class="font-bold">
                        Complemento: {{ address.complement }}</span
                      >
                      <br />
                      Bairro: {{ address.neighborhood }}, Cidade:
                      {{ address.city }} - {{ address.uf }}
                    </p>
                  </div>

                  <div class="w-full md:w-5/12 md:mb-0 p-4 md:p-4 bg-gray-200">
                    <ValidationProvider rules="required" v-slot="{ errors }">
                      <input-icon
                        :icon="{ name: 'map' }"
                        id="address_number"
                        name="address_number"
                        type="text"
                        v-model="address.number"
                        label="Numero:"
                      ></input-icon>
                      <span
                        class="text-red-500 block pt-1"
                        v-if="errors.length"
                      >
                        <i class="bx bx-error mr-1"></i>
                        {{ errors[0] }}
                      </span>
                    </ValidationProvider>
                  </div>
                  <div
                    class="w-full md:w-7/12 md:mb-0 p-0 px-4 py-2 md:p-4 bg-gray-200"
                  >
                    <input-icon
                      :icon="{ name: 'map' }"
                      id="address_complement"
                      name="address_complement"
                      type="text"
                      v-model="address.complement"
                      label="Complemento:"
                    ></input-icon>
                    <small class="text-gray-600 text-xs"
                      >Ex: BLOCO 3 AP 42</small
                    >
                  </div>
                </div>
              </div>
              <div class="w-full p-2">
                <input-icon
                  :icon="{ name: 'info-square', type: 'solid' }"
                  id="observation"
                  name="observation"
                  type="text"
                  v-model="observation"
                  label="Observação:"
                ></input-icon>
              </div>
              <div class="w-full p-2 my-5 border-t border-dashed pt-6">
                <button-icon
                  icon="plus"
                  :text="
                    this.$route.params.category
                      ? `Atualizar Categoria`
                      : `Adicionar Cliente`
                  "
                  class="bg-indigo-600"
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </content-e>
  </section-container>
</template>

<script>
import InputSearch from '@/components/Form/InputSearch'
import { extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
extend('email', email)

// Override the default message.
extend('required', {
  ...required,
  message: 'Esse campo é obrigatório'
})

extend('email', {
  ...email,
  message: 'Endereço de e-mail não é valido'
})
export default {
  components: {
    InputSearch
  },
  computed: {
    store() {
      return this.$store.state.store
    }
  },
  watch: {
    zipcode() {
      if (this.zipcode.length === 9) {
        this.doAddress()
      } else {
        this.address_card = false
      }
    }
  },
  data() {
    return {
      products: [],
      products_selects: [],
      name: null,
      email: null,
      phone: null,
      zipcode: null,
      address: {},
      address_card: false,
      payment_method: '',
      observation: null
    }
  },
  methods: {
    openModal(ref) {
      this.$refs[ref].open()
    },
    closeModal(ref) {
      this.$refs[ref].close()
    },
    removeProduct(product) {
      const productBeforeRemove = this.products_selects.filter(element => {
        return element.id !== product.id
      })
      this.products_selects = productBeforeRemove
    },
    existProduct(product) {
      const exist = this.products_selects.find(element => {
        return element.id === product.id
      })

      if ((exist === undefined) | (exist === false)) {
        return false
      } else {
        return true
      }
    },
    selectProduct(product) {
      if (!this.existProduct(product)) {
        this.products_selects.push({
          id: product.id,
          name: product.name,
          quantity: 1,
          store_id: product.store_id
        })
      }
    },
    async doProducts(search) {
      const products = await this.$store.dispatch('store/MY_PRODUCT_BY_STORE', {
        search
      })
      this.products = products.data.data
    },
    doAddress() {
      this.$store
        .dispatch('util/getAddressByCep', this.zipcode)
        .then(response => {
          const address = response.data
          this.address = {
            zipcode: address.data.cep,
            street: address.data.logradouro,
            complement: address.data.complemento,
            neighborhood: address.data.bairro,
            city: address.data.localidade,
            uf: address.data.uf,
            ddd: address.data.ddd
          }
          this.address_card = !this.address_card
        })
    },
    doCreateOrder() {
      const order = {
        customer: {
          name: this.name,
          email: this.email,
          phone: this.phone,
          store_payment_method_id: this.payment_method
        },
        cart: {
          items: this.products_selects
        },
        observation: this.observation
      }
      this.$store
        .dispatch('CREATE_ORDER', order)
        .then(response => {
          this.$toasted.success('Pedido criado com sucesso!', {
            position: 'bottom-center',
            duration: 5000,
            icon: 'check'
          })
          this.$router.push({ name: 'orders.index' })
        })
        .catch(error => {
          const msg = Object.values(error.data.errors)
          msg.forEach((item, i) => {
            this.$toasted.error(item, {
              position: 'top-center',
              duration: 5000,
              icon: 'close'
            })
          })
        })
    }
  }
}
</script>

<style></style>
